import { render, staticRenderFns } from "./LoginHistoryDashboard.vue?vue&type=template&id=0676fdd8&scoped=true"
import script from "./LoginHistoryDashboard.vue?vue&type=script&lang=js"
export * from "./LoginHistoryDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676fdd8",
  null
  
)

export default component.exports